function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#c2a633"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.29 7.906h-1.716v3.383h2.696v1.414h-2.696v3.379h1.797c.465 0 3.793.055 3.79-3.93-.005-3.984-3.231-4.246-3.872-4.246zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.371 0 0 5.371 0 12s5.371 12 12 12 12-5.371 12-12S18.629 0 12 0zm.473 18.48H8.125v-5.777H6.594V11.29h1.531V5.512h3.73c.883 0 6.727-.184 6.727 6.593 0 6.887-6.11 6.375-6.11 6.375zm0 0"
}));

function SvgDoge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default __webpack_public_path__ + "fcd560b120b4511b957724442a47b3fd.svg";
export { SvgDoge as ReactComponent };